import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { 
  TextField, 
  Button, 
  Typography, 
  Container, 
  Box, 
  Alert,
} from '@mui/material';
import {
  Save as SaveIcon,
} from '@mui/icons-material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

import { updateLead, getLeads, createLead, createProject } from '../api';

interface Lead {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  notes: string;
  manager?: string;
  status: string;
  archived: boolean;
}

const LeadForm: React.FC = () => {
  const [newLead, setNewLead] = useState<Omit<Lead, 'id' | 'archived'>>({ firstName: '', lastName: '', email: '', phone: '',  address: '', city: '', state: '', zip: '', manager: '', notes: '', status: 'Open' });
  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<string>('');
  const { manager } = useParams();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewLead({ ...newLead, [name]: value });
  };

  const handleSaveLead = async () => {
    const data = {
      ...newLead,
      manager,
      status: 'Lead Form'
    }

    setMessage('');
    setError('');

    try {
      await createLead(data)
      setMessage('Lead created successfully');
    }catch (err: any) {
      console.error('Error creating lead:', err);
      setError(err.response?.data?.message || 'An error occurred while creating the lead');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{ 
          mt: 8, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          backgroundColor: 'background.paper',
          padding: 3,
          borderRadius: 2,
          boxShadow: 3
        }}
      >
        <Typography component="h1" variant="h5" gutterBottom>
          Lead Form
        </Typography>

        { message && (
          <Alert severity="info" sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}
        { error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <TextField
            fullWidth
            label="First Name"
            name="firstName"
            value={newLead.firstName}
            onChange={handleInputChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Last Name"
            name="lastName"
            value={newLead.lastName}
            onChange={handleInputChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={newLead.email}
            onChange={handleInputChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Phone"
            name="phone"
            type="phone"
            value={newLead.phone}
            onChange={handleInputChange}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Address"
            name="address"
            value={newLead.address}
            onChange={handleInputChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="City"
            name="city"
            value={newLead.city}
            onChange={handleInputChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="State"
            name="state"
            value={newLead.state}
            onChange={handleInputChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Zip Code"
            name='zip'
            value={newLead.zip}
            onChange={handleInputChange}
            margin="normal"
          />

          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={handleSaveLead}
            fullWidth
            sx={{
              mt: 4,
            }}
          >
            Save
          </Button>
      </Box>

    </Container>
  );
};

export default LeadForm;